<script setup>
import { useAppStore } from '~/store/main'

defineProps({
  logoVisibility: {
    type: Boolean,
    default: true,
  },
  logoVariant: {
    type: String,
    default: '',
    // orange
    // white
    // black
    // negative_orange
    // negative_white
    // negative_black
  },
})

const logo = ref(null)
const showLogo = ref(true)
const logoHeight = ref(0)
const clientHeight = ref(0)

const store = useAppStore()

const coordinates = computed(() => {
  const top =
    (clientHeight.value + store.getHeaderHeight - 59 - logoHeight.value) / 2
  return top
})

const handleResize = () => {
  logoHeight.value = logo.value?.offsetHeight || 0
  clientHeight.value = document.documentElement.clientHeight
}

const onScroll = () => {
  const triggerHeight =
    (clientHeight.value - store.getHeaderHeight + 59) / 2 - logoHeight.value
  showLogo.value = window.pageYOffset <= triggerHeight
}

onMounted(() => {
  if (import.meta.client) {
    window.addEventListener('resize', handleResize)
    window.addEventListener('scroll', onScroll)

    handleResize()

    nextTick(() => {
      logoHeight.value = logo.value?.offsetHeight || 0
      clientHeight.value = document.documentElement.clientHeight
    })
  }
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize)
  window.removeEventListener('scroll', onScroll)
})
</script>

<template>
  <section>
    <Transition name="logoFade">
      <h1
        v-if="showLogo && logoVisibility"
        ref="logo"
        class="text_logo logoColor"
        :class="logoVariant"
        :style="{ top: coordinates + 'px' }"
      >
        <span>avu</span>
      </h1>
    </Transition>
  </section>
</template>

<style lang="scss" scoped>
.orange {
  color: $color-logo;
}
.white {
  color: white;
}
.black {
  color: black;
}
.negative_orange {
  mix-blend-mode: difference;
  color: $color-logo;
}
.negative_white {
  mix-blend-mode: difference;
  color: white;
}
.negative_black {
  mix-blend-mode: difference;
  color: rgb(52, 52, 52);
}

.text_logo {
  font-family: $font-display3;
  font-size: calc(min(62.86vw, 180px));
  font-weight: $font-weight-normal;
  letter-spacing: -3.6px;

  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 2;
  transform: translate(-50%, 0);

  display: flex;
  justify-content: center;
  align-items: center;

  height: 0.5em;
  margin: 0;

  pointer-events: none;

  @include media-breakpoint-up(sm) {
    font-size: calc(min(385/1440 * 100vw));
  }

  span {
    position: relative;
    top: -0.1em;
    line-height: 0;
  }
}

.logoFade-enter-active,
.logoFade-leave-active {
  transition: opacity 0.5s ease;
}

.logoFade-enter-from,
.logoFade-leave-to {
  opacity: 0;
}
</style>
